import { SortInput } from 'components/Table'
import { SortBy } from './hooks/useGetBidders/types'

export const DEFAULT_SORT: SortInput<SortBy> = {
  by: 'code',
  direction: 'asc',
} as const

export const SORTABLE_COLUMNS: SortBy[] = ['code', 'name']
